<script setup>
defineProps({
  name:  { type: String, required: true },
  label: { type: String, default: '' },
  size:  { type: String, default: 'md' },
  // Any CSS colour value (e.g. "var(--color-primary)"). Empty = the default
  // below (var(--color-ink), matching body text) — set via an inline style
  // rather than relying on ambient/inherited CSS, so it always wins
  // regardless of stylesheet load order between this component and its
  // parent's own scoped styles.
  color: { type: String, default: '' },
})
</script>

<template>
  <span
    class="icon-symbol"
    :class="size"
    :style="color ? { color } : undefined"
    :aria-hidden="label ? undefined : 'true'"
    :role="label ? 'img' : undefined"
    :aria-label="label || undefined"
  >{{ name }}</span>
</template>

<style lang="scss" scoped>
.icon-symbol {
  // The self-hosted font is a static instance already pinned to these exact
  // axis values (see scripts/subset-icon-font.mjs) — no font-variation-settings
  // needed, there's nothing left to vary.
  font-family: $font-icon;
  line-height: 1;
  display: inline-block;
  vertical-align: middle;
  user-select: none;
  letter-spacing: normal;
  text-transform: none;
  white-space: nowrap;
  word-wrap: normal;
  font-feature-settings: 'liga';
  color: var(--color-ink);   // default; override via the `color` prop

  &.sm { font-size: $icon-size-sm; }
  &.md { font-size: $icon-size-md; }
  &.lg { font-size: $icon-size-lg; }
  &.xl { font-size: $icon-size-xl; }
}
</style>
